
import React from "react";
import Btn from "../common/Btn";
import { i18nManager } from "../../i18n";
import { pagePath } from "../../helpers";
import SectionHead from "../common/SectionHead";
import ManagerCard from "../common/ManagerCard";
import styles from "../../assets/style.module.css";
import { IHostManager } from "../../../../../services";

export interface CrewProps {
    basePath: string;
    managers: IHostManager[];
    onSelect: (m: IHostManager) => void;
}

function Crew({ basePath, managers, onSelect }: CrewProps) {

    const labels = i18nManager.Labels.home;

    return (<section className={styles["section"]}>
        <div className={styles["container"]}>
            <SectionHead tag={labels.crew} title={labels.crew_title} action={<Btn variant="outline" size="sm" to={{ pathname: pagePath(basePath, "ABOUT"), hash: "team" }}>{i18nManager.Labels.view_all}</Btn>} />
            <div className={styles["crew-grid"]}>
                {managers.map((m, i) => (<ManagerCard key={m.external_id} index={i} manager={m} onSelect={onSelect} />))}
            </div>
        </div>
    </section>);
}

export default Crew;
